import axios from 'axios';

export const mapService = {
    /**
     * Clients & Staff Map pins. Single endpoint returns both layers already merged:
     * `{ clients: MapPinDTO[], staff: MapPinDTO[] }`. `staffStatuses` / `clientStatuses` pick which
     * statuses are plotted (server-side); person and state/city filters are applied client-side.
     */
    getMapPinsService: (params) => axios.get('/map/pins', { auth: true, params }),
};
